// @flow
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_SORT_ORDER = 'asc';
export const DEFAULT_NO_ROWS_TEXT = 'No results found';
export const DEFAULT_VARIANT = 'striped';
export const DEFAULT_DENSITY = 'comfortable';
export const DEFAULT_ELEVATION = 1;
export const PLACEHOLDER_TEXT = '-';
